export enum WorkflowEditorMode {
  EditWorkflow = 'edit-workflow',
  AppBuilder = 'app-builder',
}
